/**
 * AWS Amplify Configuration
 * Configure Cognito authentication for the AI Learning Assistant
 */

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_YoV7BkPQx',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '30krvljbptq3lckrn6uq5riksg',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || 'us-east-1:4e259fdf-b406-443a-bc88-733fac3bcc40',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: false,
      },
    },
  },
};
